import { toast } from "react-toastify"
import { COLORS } from "../styles/variables"

/** Проверка токена на каждый рендер (предпочтительно для маршрутизации). */
export const getIsAuth = (): boolean => {
    // В cookie-auth (HttpOnly) фронт не может синхронно узнать auth-состояние.
    // Источник истины — успешный запрос профиля `/auth/me` / `getProfile`.
    // Эта функция оставлена только для обратной совместимости и должна быть удалена.
    return false
}

/** Снимок на момент загрузки модуля; для UI маршрутов используйте getIsAuth(). */
export const isAuth = getIsAuth()

export const getError = (message?: string, skip?: boolean) => {
    if (message && !skip) {
        toast.error(message)
        return message
    }
    return null
}

/** ISO / Laravel datetime: берём первые 10 символов YYYY-MM-DD → DD.MM.YYYY */
export const formatApiDateToDdMmYyyy = (isoOrDateString: string | null | undefined): string => {
    if (isoOrDateString == null) return ""
    const s = String(isoOrDateString).trim()
    if (s === "") return ""
    const head = s.slice(0, 10)
    if (!/^\d{4}-\d{2}-\d{2}$/.test(head)) {
        return ""
    }
    const [y, m, d] = head.split("-")
    return `${d}.${m}.${y}`
}

/** ISO8601 / Laravel: дата и время в локальной зоне (для лент комментариев). При неполном входе — откат к DD.MM.YYYY. */
export const formatApiDateTimeComment = (isoOrDateString: string | null | undefined): string => {
    if (isoOrDateString == null) return ""
    const s = String(isoOrDateString).trim()
    if (s === "") return ""
    const t = Date.parse(s)
    if (Number.isNaN(t)) return formatApiDateToDdMmYyyy(s)
    const d = new Date(t)
    return d.toLocaleString("ru-RU", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    })
}

export const websiteHref = (website: string): string =>{
    const s = website.trim()
    if (/^https?:\/\//i.test(s)) return s
    return `https://${s}`
}

export const requiredTitle = (text: string) => (
    <>
        {text}
        <span style={{ 
            color: COLORS.CADMIUM_RED, 
            marginLeft: 4, 
            verticalAlign: "baseline", 
            lineHeight: "inherit" }}
        >
            *
        </span>
    </>
)